module.exports = __webpack_public_path__ + "img/66-78-plan.61e37407.jpg";